module.exports = __webpack_public_path__ + "img/40-VKB.44311ba.png";